import { fg } from '@confluence/feature-gating';
import { StatsigConfigurations } from '@confluence/statsig-client/entry-points/StatsigConfigurations';

import type { AdfStats } from './useAdfStats';

const STATSIG_DYNAMIC_CONFIG = 'cc_complexit_fe_progressive_adf_rendering_configs';

type IsComplexPageReason = 'TooManyNodes' | 'TooManyExtensions' | 'None';

type UseProgressiveRenderingConfigResponseType = {
	isComplexPage: boolean;
	isComplexPageReason: IsComplexPageReason;
	batchSize: number;
};

type UseProgressiveRenderingConfigProps = {
	skip?: boolean;
	totalNodeCount: AdfStats['totalNodeCount'];
	nodeCountByType: AdfStats['nodeCountByType'];
};

export const useProgressiveRenderingConfig = ({
	skip,
	totalNodeCount,
	nodeCountByType,
}: UseProgressiveRenderingConfigProps): UseProgressiveRenderingConfigResponseType => {
	let isComplexPage = false;
	let isComplexPageReason: IsComplexPageReason = 'None';
	let batchSize = 0;

	if (!skip) {
		const defaultConfig = StatsigConfigurations.getString(STATSIG_DYNAMIC_CONFIG, '').split(',');
		const batchSizeConfig = Number(defaultConfig[0]) || 1000;
		const multiplierConfig = Number(defaultConfig[1]) || 10;

		// Figure out whether progressive rendering is to be enabled:
		if (totalNodeCount >= batchSizeConfig * multiplierConfig) {
			isComplexPage = true;
			isComplexPageReason = 'TooManyNodes';
			batchSize = batchSizeConfig;
		} else if (
			nodeCountByType['extension'] > 4 &&
			fg('cc_complexit_fe_progessive_rendering_extensions')
		) {
			isComplexPage = true;
			isComplexPageReason = 'TooManyExtensions';
		}
	}

	return {
		isComplexPage,
		isComplexPageReason,
		batchSize,
	};
};
